export default function generateUniqueId() {
    return "".concat(Date.now(), "-").concat(Math.round(Math.random() * 1e9));
}
